module.exports = __webpack_public_path__ + "static/media/cat_blue.0931be8a.png";